var ColumnMiddleware = /** @class */ (function () {
    function ColumnMiddleware() {
    }
    /**
     * @param {Columns} model
     * @param {Object} config
     */
    ColumnMiddleware.map = function (model, config) {
        Object.keys(config).forEach(function (column_name) {
            var editing_settings = config[column_name];
            var settings = model.get(column_name);
            settings.editable = editing_settings.editable;
            settings.type = editing_settings.type;
            settings.editable.inline_edit = editing_settings.inline_edit;
            if (!settings.editable.hasOwnProperty('bulk_editable')) {
                settings.editable.bulk_editable = editing_settings.bulk_edit;
            }
        });
        return model;
    };
    return ColumnMiddleware;
}());
export default ColumnMiddleware;
